import { toast } from 'react-toastify';
import { toastErrorAndWarningOptions, toastDefaultOptions } from './functions'

export default function showToast(response, isError) {
    const defaultMessage = isError ? 'Não foi possivel realizar a operação' : 'Sucesso!';
    toast(
        response.message ? response.message : defaultMessage,
        isError ? toastErrorAndWarningOptions : toastDefaultOptions
    );
}